import * as signalR from '@aspnet/signalr';
import {store} from './store';

let connectionAttempt = 0;
export let connection;
let freeMatrixUpdateUsed = false;

export const createConnection = (token) => {
  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.VUE_APP_API}/hubs/compass`, {
      accessTokenFactory: () => token,
    })
    .build();
};

export const start = () => {

  connection.start()
    .then(() => {
      connectionAttempt = 0;
    })
    .catch(err => {
      console.log(err);
      setTimeout(() => {
        if (connectionAttempt <= 15) {
          start();
          connectionAttempt++;
        }
      }, 3000)
    });
};

export const disconnect = () => {
  if (connection) {
    connection.stop();
  }
};

export const onCloseConnection = () => {
  connection.onclose(() => {
    setTimeout(() => {
      if (connectionAttempt <= 15) {
        start();
        connectionAttempt++;
      }
    }, 3000)
  });
};

export const onCoordinatesReceived = () => {
  connection.on('CoordinatesReceived', async data => {
    const coordinates = JSON.parse(data);
    await store.dispatch('setUserCoordinates', {coordinates});
    if (!freeMatrixUpdateUsed) {
      const origins = `${store.getters.user.lat},${store.getters.user.lng}`;
      const destinations = `${store.getters.contact.lat},${store.getters.contact.lng}`;
      await store.dispatch('getEstimatedDistance', {
        origins,
        destinations
      });
      freeMatrixUpdateUsed = true;
    }
  })
};

export const onRevokeTracker = () => {
  connection.on('RevokeTracker', async data => {
    console.log('yay');
    await store.dispatch('revokeTracker');
  });
};
